module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-light-webfont.c0854ea0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-light-webfont.woff
// module id = 365
// module chunks = 3